var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zhgl"},[_c('div',{staticClass:"webWrap"},[_c('div',{staticClass:"webCont"},[_c('div',{staticClass:"indexTitle",staticStyle:{"margin-bottom":"-113px"}},[_c('p',[_vm._v("智慧管理系统")])]),_c('div',{staticClass:"cont wow animate__fadeInUp"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"static/lvya/zhgl/jwglimg.png","alt":""}})])])])])
}]

export { render, staticRenderFns }